// extracted by mini-css-extract-plugin
export default {"otherCBDCContainer":"styles_otherCBDCContainer__KFvXj"};